import { FileCode2, Home } from "lucide-react";
import { cn } from "@/lib/utils";
import type { BrandSitePage } from "@/lib/brand-site-api";

type Props = {
  pages: BrandSitePage[];
  selectedSlug: string | null;
  onSelectSlug: (slug: string) => void;
};

/** IDE 左栏：按 `/pages/{slug}.html` 展示页面路径（首页标 is_home）。 */
export function BrandSiteIdeFileTree({ pages, selectedSlug, onSelectSlug }: Props) {
  const sorted = [...pages].sort((a, b) => {
    if (a.is_home !== b.is_home) return a.is_home ? -1 : 1;
    return a.slug.localeCompare(b.slug, "zh-CN");
  });

  return (
    <nav className="flex min-h-0 flex-1 flex-col" aria-label="模板文件树">
      <div className="border-b border-border px-3 py-2">
        <p className="text-xs font-medium text-muted-foreground">pages/</p>
      </div>
      <ul className="min-h-0 flex-1 overflow-y-auto px-1 py-1" role="tree">
        {sorted.length === 0 ? (
          <li className="px-3 py-4 text-xs text-muted-foreground">还没有页面</li>
        ) : (
          sorted.map((page) => {
            const path = `/pages/${page.slug}.html`;
            const active = page.slug === selectedSlug;
            const Icon = page.is_home ? Home : FileCode2;
            return (
              <li key={page.id} role="treeitem" aria-selected={active}>
                <button
                  type="button"
                  className={cn(
                    "flex w-full items-start gap-2 rounded-md px-2 py-1.5 text-left text-sm transition-colors",
                    active
                      ? "bg-primary/10 text-primary-readable"
                      : "text-foreground hover:bg-muted/60",
                  )}
                  onClick={() => onSelectSlug(page.slug)}
                >
                  <Icon className="mt-0.5 size-3.5 shrink-0 opacity-70" aria-hidden />
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-mono text-xs">{path}</span>
                    <span className="block truncate text-[11px] text-muted-foreground">
                      {page.title || page.slug}
                      {page.is_home ? " · 首页" : ""}
                    </span>
                  </span>
                </button>
              </li>
            );
          })
        )}
      </ul>
    </nav>
  );
}
